module.exports = __webpack_public_path__ + "static/media/etherscan.b43266ae.png";